import React, { Component } from "react";
import PropTypes from "prop-types";
import { ID_PREFIX_BOX, ID_PREFIX_PAGE, PAGE_TYPES } from "../../../../common/constants";
import i18n from "i18next";
import { availableTemplates } from "./templates/templates";
import "./_templatesModal.scss";
import AppModal from "../../common/modal/AppModal";
import TemplateThumbnail from "./TemplateThumbnail";
import { createBox } from "../../../../common/common_tools";
import { contentT } from "../../../../common/content_language";
import ZipImportModal from "../../canvas/editor_box/screen_training/importer/ZipImportModal";
import { addDefaultSceneHeader } from "../../canvas/scene_header_factory";
import { isClmAllowedPlugin } from "../../../../common/clm";

// CLM courses only offer templates whose boxes are all allowlisted plugins —
// mirrors the palette/clipboard gating in common/clm.es6 (spec §3.3 item 1).
export const isTemplateClmAllowed = (template) =>
  template.boxes.every((item) => isClmAllowedPlugin(item.toolbar.name));

export default class TemplatesModal extends Component {
  constructor(props) {
    super(props);
    this.index = 0;
    this.templates = availableTemplates();
    /**
     * Component's initial state
     */
    this.state = {
      itemSelected: -1,
      activeTab: "template", // "template" | "zip"
    };
  }
  render() {
    // CLM courses: Screen Training ZIP import inserts GuideMultiInput/
    // GuideTagDisplay, neither allowlisted (common/clm.es6) — hide the tab
    // (mirrors the template-list gate below via isTemplateClmAllowed).
    const isZipTab = this.state.activeTab === "zip" && !this.props.isClm;

    return (
      <AppModal
        id="TemplatesModal"
        show={this.props.show}
        onClose={() => this.closeModal()}
        title={<span id="previewTitle">{i18n.t("templates.templatechose")}</span>}
        size="lg"
        maxWidth="600px"
        backdrop="static"
        cancelLabel={i18n.t("importFile.footer.cancel")}
        onCancel={() => this.closeModal()}
        confirmLabel={isZipTab ? undefined : i18n.t("importFile.footer.ok")}
        onConfirm={() => this.AddNavItem(this.state.itemSelected)}
      >
        <div className="templates-modal__tabs">
          <button
            type="button"
            className={this.state.activeTab === "template" ? "active" : ""}
            onClick={() => this.setState({ activeTab: "template" })}
          >
            {i18n.t("templates.tab_template") || "From Template"}
          </button>
          {!this.props.isClm && (
            <button
              type="button"
              className={this.state.activeTab === "zip" ? "active" : ""}
              onClick={() => this.setState({ activeTab: "zip" })}
            >
              {i18n.t("templates.tab_zip") || "Screen Training"}
            </button>
          )}
        </div>

        {isZipTab ? (
          <ZipImportModal
            onImportComplete={() => this.closeModal()}
            onNavItemAdded={this.props.onNavItemAdded}
            onBoxAdded={this.props.onBoxAdded}
            boxes={this.props.boxes}
          />
        ) : (
          <div className="items_container">
            <div
              id="empty"
              className="template_item"
              key="-1"
              style={{
                width: "120px",
                height: "80px",
                border: this.state.itemSelected === -1 ? "solid #a963f5 3px" : "solid #b0b2b6 1px",
                position: "relative",
              }}
              onClick={() => {
                this.setState({ itemSelected: -1 });
              }}
              onDoubleClick={() => {
                this.setState({ itemSelected: -1 });
                this.AddNavItem(-1);
              }}
            >
              <div
                className={"template_name"}
                style={{ display: this.state.itemSelected === -1 ? "block" : "none" }}
              >
                {i18n.t("templates.template0")}
              </div>
            </div>
            {this.templates
              .map((item, index) => ({ item, index }))
              .filter(({ item }) => !this.props.isClm || isTemplateClmAllowed(item))
              .map(({ item, index }) => {
                let border =
                  this.state.itemSelected === index ? "solid #a963f5 3px" : "solid #b0b2b6 1px";
                return (
                  <div
                    key={index}
                    className="template_item"
                    style={{ position: "relative", border: border, width: "120px", height: "80px" }}
                  >
                    <TemplateThumbnail
                      key={index}
                      index={index}
                      onClick={() => {
                        this.setState({ itemSelected: index });
                      }}
                      onDoubleClick={() => {
                        this.setState({ itemSelected: index });
                        this.AddNavItem(index);
                      }}
                      boxes={item.boxes}
                    />
                    <div
                      className={"template_name"}
                      style={{
                        display: "block",
                        backgroundColor: this.state.itemSelected === index ? "#a963f5" : "#ccc",
                      }}
                    >
                      {i18n.t(item.name)}
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </AppModal>
    );
  }

  /**
   * Close modal
   */
  closeModal() {
    // reset state
    this.setState({ itemSelected: -1, activeTab: "template" });
    this.props.close();
  }
  /**
   * Add Slide
   */
  AddNavItem(template) {
    let newId = ID_PREFIX_PAGE + Date.now();

    if (this.props.show) {
      this.props.onNavItemAdded(
        newId,
        i18n.t("slide"),
        // this.getParent().id,// Calculated in CarrouselButtons
        PAGE_TYPES.SLIDE,
        // this.props.calculatePosition(), // Calculated in CarrouselButtons
        "rgb(255,255,255)",
        0,
        template !== -1,
        false
      );
      // Default scene header: drop an editable BasicText box at the top of the
      // brand-new empty scene so users see a familiar header layout
      // (replaces the legacy in-canvas EditorHeader). Skipped when a real
      // template is being instantiated — those templates ship their own
      // heading element already.
      if (template === -1) {
        addDefaultSceneHeader({
          navItemId: newId,
          onBoxAdded: this.props.onBoxAdded,
          boxes: this.props.boxes,
        });
      }
      if (template !== -1) {
        let selectedTemplate = this.templates[template];
        let boxes = selectedTemplate.boxes;

        boxes.map((item, index) => {
          let position = {
            x: item.box.x,
            y: item.box.y,
            type: "absolute",
          };
          let initialParams = {
            id: ID_PREFIX_BOX + Date.now() + "_" + index,
            parent: newId,
            container: 0,
            col: 0,
            row: 0,
            width: item.box.width,
            height: item.box.height,
            position: position,
            name: item.toolbar.name,
            isDefaultPlugin: true,
            page: newId,
          };
          if (item.toolbar.text) {
            initialParams.text = item.toolbar.text;
          } else if (item.toolbar.url) {
            initialParams.url = item.toolbar.url;
          }
          if (item.toolbar.initialState) {
            initialParams.initialState = {
              ...(initialParams.initialState || {}),
              ...item.toolbar.initialState,
            };
            if (initialParams.initialState.__i18nKey) {
              const prefix =
                initialParams.initialState.__prefix !== undefined
                  ? initialParams.initialState.__prefix
                  : "<p>";
              const suffix =
                initialParams.initialState.__suffix !== undefined
                  ? initialParams.initialState.__suffix
                  : "</p>";
              initialParams.initialState.__text =
                prefix + contentT(initialParams.initialState.__i18nKey) + suffix;
            }
          }
          createBox(
            initialParams,
            item.toolbar.name,
            true,
            this.props.onBoxAdded,
            this.props.boxes,
            item.toolbar.style
          );
        });
      }
      // reset state
      this.setState({
        itemSelected: -1,
      });
      // this.props.onIndexSelected(newId);
      this.props.close();
    }
  }
}
TemplatesModal.propTypes = {
  /**
   * Whether the import file modal should be shown or hidden
   */
  show: PropTypes.bool,
  /**
   * Closes import file modal
   */
  close: PropTypes.func.isRequired,
  /**
   * Function for adding a new view
   */
  onNavItemAdded: PropTypes.func.isRequired,
  /**
   *  Object containing all created boxes (by id)
   */
  boxes: PropTypes.object.isRequired,
  /**
   * Function for adding a new box
   */
  onBoxAdded: PropTypes.func.isRequired,
  /**
   * Whether this is a CLM course — only allowlisted-plugin templates are offered
   */
  isClm: PropTypes.bool,
};
